<template>
  <div>
    <FrontPageTenantBanner />

    <div class="container">

      <div v-if="tenant.data.introduction">
        <h2>Who we are</h2>
        <p v-html="$options.filters.convertLinebreaks(tenant.data.introduction)"></p>
      </div>

      <div v-if="auctions.length > 0">
        <h2>Our auctions</h2>
        <div class="clearfix live-auctions">
          <div class="four-column" v-for="a in auctions" :key="a.id">
            <ListingItem :auction="a" />
          </div>
          <div v-if="loading" class="loading">
            <div class="four-column"></div>
            <div class="four-column"></div>
            <div class="four-column"></div>
            <div class="four-column"></div>
          </div>
        </div>
        <div class="align-right">
          <router-link to="/listings"><button btn="btn-neutral">Browse auctions</button></router-link>
        </div>
      </div>

    </div>

  </div>
</template>

<script>

  import FrontPageTenantBanner from './FrontPageTenantBanner.vue'
  import ListingItem from './ListingItem.vue'
  import { auctionStatusIndex } from '../utils/PfxUtils.js'
  import { mapGetters } from 'vuex'

  export default {
    name: 'FrontPageTenant',
    components: {
      FrontPageTenantBanner,
      ListingItem
    },
    data() {
      return {
        tenant: this.$store.state.tenant,
        auctions: [],
        loading: true
      }
    },
    computed: {
      ...mapGetters([
        'subdomain'
      ])
    },
    created() {
      console.log('tenant', this.tenant)
      this.getAuctions()
    },
    mounted() {
      // subscribe to auction events
      this.$events.on('auction', update => {
        this.auctions
          .filter(auction => auction.id === update.id)
          .map(auction => Object.assign(auction, update))
      })
    },
    beforeDestroy() {
      this.$events.off('auction')
    },
    methods: {
      getAuctions() {
        this.auctions = []
        const that = this
        this.loading = true
        this.$PfxBackendApi.getPublicAuctions(this.subdomain, 3).then(res => {
          console.log('getPublicAuctions res', res)
          that.auctions = that.sortAuctions(res.data.data || []).slice(0, 4)
        }).catch(err => {
          console.error('getPublicAuctions err', err)
        }).then(() => that.loading = false)
      },
      sortAuctions(auctions) {
        auctions.sort((a, b) => {
          const aa = auctionStatusIndex(a.status)
          const bb = auctionStatusIndex(b.status)
          return aa < bb ? -1 : aa === bb ? 0 : 1
        })
        return auctions
      }

    }
  }
</script>

<style lang="scss" scoped>
  @import '../pfx.scss';

  .four-column {
    @include stack();
    @include tablet-portrait-breakpoint {
      @include column(1/2, $cycle: 2);
    }
    @include tablet-landscape-breakpoint {
      @include column(1/3, $cycle: 3);
    }
    @include desktop-breakpoint {
      @include column(1/4, $cycle: 4);
    }
  }
  .loading .four-column {
    background-color: #eee;
    height: 19.5rem;
  }

</style>



// WEBPACK FOOTER //
// src/components/FrontPageTenant.vue